var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperatureMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12849)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.765 11.5274C18.5578 11.5274 18.39 11.3595 18.39 11.1523V3.68116C18.39 3.47397 18.5578 3.30615 18.765 3.30615C18.9722 3.30615 19.14 3.47397 19.14 3.68116V11.1523C19.14 11.3595 18.9722 11.5274 18.765 11.5274Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8427 7.04497C20.7246 7.04497 20.6074 6.98872 20.5342 6.88371L18.7642 4.33844L16.9941 6.88371C16.876 7.05341 16.6416 7.0956 16.4719 6.97747C16.3022 6.85934 16.26 6.6259 16.3782 6.45526L18.4567 3.46741C18.527 3.36615 18.6414 3.30615 18.7642 3.30615C18.887 3.30615 19.0023 3.36615 19.0717 3.46741L21.1502 6.45526C21.2683 6.62495 21.2261 6.85933 21.0564 6.97747C20.9908 7.02247 20.9168 7.04497 20.8427 7.04497Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4205 24.7146C9.73724 24.7146 7.55557 22.532 7.55557 19.8497C7.55557 18.2568 8.32247 16.7857 9.61815 15.8727V3.51788C9.61815 1.9719 10.8754 0.7146 12.4214 0.7146C13.9674 0.7146 15.2247 1.97183 15.2247 3.51788V15.8727C16.5194 16.7859 17.2873 18.2569 17.2873 19.8497C17.2873 22.532 15.1047 24.7146 12.4216 24.7146H12.4205ZM12.4205 1.46486C11.288 1.46486 10.3673 2.38551 10.3673 3.51805V16.0726C10.3673 16.2001 10.3026 16.3191 10.1958 16.3876C9.0126 17.1498 8.3057 18.4445 8.3057 19.8499C8.3057 22.1188 10.1517 23.9649 12.4213 23.9649C14.6902 23.9649 16.537 22.1189 16.537 19.8499C16.537 18.4446 15.8301 17.1499 14.6469 16.3876C14.5401 16.3182 14.4754 16.2001 14.4754 16.0726V3.51901C14.4754 2.38743 13.5547 1.46582 12.4222 1.46582L12.4205 1.46486Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.421 22.1533C11.1506 22.1533 10.1165 21.1192 10.1165 19.8489C10.1165 18.5785 11.1506 17.5444 12.421 17.5444C13.6914 17.5444 14.7255 18.5785 14.7255 19.8489C14.7255 21.1192 13.6914 22.1533 12.421 22.1533ZM12.421 18.2945C11.5641 18.2945 10.8666 18.992 10.8666 19.8489C10.8666 20.7058 11.5641 21.4034 12.421 21.4034C13.2779 21.4034 13.9754 20.7059 13.9754 19.8489C13.9754 18.992 13.2779 18.2945 12.421 18.2945Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4205 18.2954C12.2134 18.2954 12.0455 18.1276 12.0455 17.9204V3.61744C12.0455 3.41025 12.2134 3.24243 12.4205 3.24243C12.6277 3.24243 12.7956 3.41025 12.7956 3.61744V17.9204C12.7956 18.1276 12.6277 18.2954 12.4205 18.2954Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00077 17.5687C5.79358 17.5687 5.62576 17.4009 5.62576 17.1937V1.18165C5.62576 0.974458 5.79358 0.806641 6.00077 0.806641C6.20797 0.806641 6.37579 0.974458 6.37579 1.18165V17.1937C6.37579 17.4009 6.20797 17.5687 6.00077 17.5687Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00061 3.29104H2.08921C1.88202 3.29104 1.7142 3.12322 1.7142 2.91603C1.7142 2.70883 1.88202 2.54102 2.08921 2.54102H6.00061C6.2078 2.54102 6.37562 2.70883 6.37562 2.91603C6.37562 3.12322 6.2078 3.29104 6.00061 3.29104Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00061 6.87698H2.08921C1.88202 6.87698 1.7142 6.70916 1.7142 6.50196C1.7142 6.29477 1.88202 6.12695 2.08921 6.12695H6.00061C6.2078 6.12695 6.37562 6.29477 6.37562 6.50196C6.37562 6.70916 6.2078 6.87698 6.00061 6.87698Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00061 10.4612H2.08921C1.88202 10.4612 1.7142 10.2934 1.7142 10.0862C1.7142 9.879 1.88202 9.71118 2.08921 9.71118H6.00061C6.2078 9.71118 6.37562 9.879 6.37562 10.0862C6.37562 10.2934 6.2078 10.4612 6.00061 10.4612Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00061 14.044H2.08921C1.88202 14.044 1.7142 13.8761 1.7142 13.669C1.7142 13.4618 1.88202 13.2939 2.08921 13.2939H6.00061C6.2078 13.2939 6.37562 13.4618 6.37562 13.669C6.37562 13.8761 6.2078 14.044 6.00061 14.044Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00013 5.08401H3.40422C3.19702 5.08401 3.02921 4.91619 3.02921 4.709C3.02921 4.5018 3.19702 4.33398 3.40422 4.33398H6.00013C6.20733 4.33398 6.37515 4.5018 6.37515 4.709C6.37515 4.91619 6.20733 5.08401 6.00013 5.08401Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00013 8.66653H3.40422C3.19702 8.66653 3.02921 8.49871 3.02921 8.29152C3.02921 8.08432 3.19702 7.9165 3.40422 7.9165H6.00013C6.20733 7.9165 6.37515 8.08432 6.37515 8.29152C6.37515 8.49871 6.20733 8.66653 6.00013 8.66653Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00013 12.2525H3.40422C3.19702 12.2525 3.02921 12.0846 3.02921 11.8775C3.02921 11.6703 3.19702 11.5024 3.40422 11.5024H6.00013C6.20733 11.5024 6.37515 11.6703 6.37515 11.8775C6.37515 12.0846 6.20733 12.2525 6.00013 12.2525Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00013 15.8352H3.40422C3.19702 15.8352 3.02921 15.6674 3.02921 15.4602C3.02921 15.253 3.19702 15.0852 3.40422 15.0852H6.00013C6.20733 15.0852 6.37515 15.253 6.37515 15.4602C6.37515 15.6674 6.20733 15.8352 6.00013 15.8352Z",
    fill: "#564AB3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.648 3.36797C16.0715 3.36797 15.6017 2.89827 15.6017 2.32168C15.6017 1.74511 16.0714 1.27539 16.648 1.27539C17.2246 1.27539 17.6943 1.74508 17.6943 2.32168C17.6943 2.89825 17.2246 3.36797 16.648 3.36797ZM16.648 2.02541C16.4849 2.02541 16.3518 2.15854 16.3518 2.32168C16.3518 2.48481 16.4849 2.61794 16.648 2.61794C16.8112 2.61794 16.9443 2.48481 16.9443 2.32168C16.9443 2.15855 16.8112 2.02541 16.648 2.02541Z",
    fill: "#564AB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#564AB3",
    transform: "translate(0 0.713867)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureMax);
export default __webpack_public_path__ + "static/media/TemperatureMax.ead541679f738835946f240513cf234d.svg";
export { ForwardRef as ReactComponent };